import React from "react";

interface IDisplayInputProps {
  text: string;
  tabIndex: number;
  onHandleBackClick: () => void;
}

const DisplayOnlyInput: React.FunctionComponent<IDisplayInputProps> = (
  props,
) => {
  const { text, tabIndex, onHandleBackClick } = props;

  return (
    <div className="form-item">
      <button
        type="button"
        className="display-input-back-button"
        aria-label="Back"
        onClick={onHandleBackClick}
      >
        <svg
          className="display-input-back-icon"
          viewBox="0 0 24 24"
          aria-hidden="true"
          focusable="false"
        >
          <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.42-1.41L7.83 13H20v-2z" />
        </svg>
      </button>
      <input
        id="email"
        value={text}
        name="email"
        type="email"
        tabIndex={tabIndex}
        readOnly={true}
        className="readonly"
        autoComplete={"username"}
      />
    </div>
  );
};

export default DisplayOnlyInput;
